import slugify from 'slugify'

interface HeadingIdOptions {
	prefix?: string
	suffix?: string
}

/**
 * Builds the anchor id for a rich-text heading.
 *
 * Without a prefix the result is identical to the ids generated before prefixes existed, so
 * headings outside accordions keep their already-published links.
 */
export const getHeadingId = (
	text: string,
	{ prefix = '', suffix = '' }: HeadingIdOptions = {},
): string =>
	slugify(
		(prefix ? prefix + '-' : '') + text + (suffix ? '-' + suffix : ''),
		{ lower: true },
	)
